import React from 'react'
import clsx from 'clsx'
import { PLAN_METADATA } from '~/service/Billing/billingConstants'
import { formatPrice } from '~/service/Billing/utils'

function PriceDisplay({ plan, selectedUnit, estimate }) {
  const meta = PLAN_METADATA[plan.unit] ?? {}
  const periodUnit = meta.periodUnit ?? ''
  const periodCycle = meta.periodCycle ?? ''
  const price = formatPrice(plan.cost_per_seat)
  return <p className='text-sm text-llama-grey-7 font-semibold pt-2'>{price}{periodUnit}{periodCycle}</p>
}

export default function ChangePlanPlanList({ plans, selectedUnit, onSelect, restrictUnit = null, estimate }) {

  return (
    <div>
      <p className='text-sm font-semibold text-llama-grey-7 mb-3'>
        2. You have selected:
      </p>
      <div className='space-y-2'>
        {plans.map((plan) => {
          const isRestrictedOut = restrictUnit != null && plan.unit !== restrictUnit
          if (isRestrictedOut) {
            return (
              <div
                key={plan.unit}
                className='flex items-center gap-3 px-4 py-3 rounded-lg border border-neutral-200 bg-neutral-50 opacity-60 cursor-not-allowed'
              >
                <div className='w-5 h-5 rounded-full border-2 border-neutral-300 bg-neutral-200 shrink-0' />
                <div className='flex-1 min-w-0'>
                  <p className='text-base font-bold text-llama-grey-7'>{plan.name}</p>
                  <PriceDisplay plan={plan} selectedUnit={selectedUnit} estimate={estimate} />
                </div>
                {plan.current && (
                  <span className='text-xs font-bold bg-neutral-200 text-llama-grey-7 px-2 py-0.5 rounded shrink-0'>
                    Current
                  </span>
                )}
              </div>
            )
          }

          if (plan.current && !plan.switchable) {
            return (
              <div
                key={plan.unit}
                className='flex items-center gap-3 px-4 py-3 rounded-lg border border-neutral-200 bg-neutral-50 opacity-60 cursor-not-allowed'
              >
                <div className='w-5 h-5 rounded-full border-2 border-neutral-300 bg-neutral-200 shrink-0' />
                <div className='flex-1 min-w-0'>
                  <p className='text-base font-bold text-llama-grey-7'>{plan.name}</p>
                  <PriceDisplay plan={plan} selectedUnit={selectedUnit} estimate={estimate} />
                </div>
                <span className='text-xs font-bold bg-neutral-200 text-llama-grey-7 px-2 py-0.5 rounded shrink-0'>
                  Current
                </span>
              </div>
            )
          }

          if (!plan.switchable) {
            return (
              <div
                key={plan.unit}
                className='flex items-center gap-3 px-4 py-3 rounded-lg border border-neutral-200 bg-white'
              >
                <div className='w-5 h-5 rounded-full border-2 border-neutral-200 shrink-0' />
                <div className='flex-1 min-w-0'>
                  <p className='text-base font-bold text-llama-grey-7'>{plan.name}</p>
                  <PriceDisplay plan={plan} selectedUnit={selectedUnit} estimate={estimate} />
                </div>
              </div>
            )
          }

          const isSelected = selectedUnit === plan.unit
          return (
            <div
              key={plan.unit}
              role='radio'
              aria-checked={isSelected}
              tabIndex={0}
              className={clsx(
                'flex items-start gap-3 px-4 py-3 rounded-lg border bg-white cursor-pointer transition-colors',
                isSelected
                  ? 'border-llama-purple-4 shadow-sm'
                  : 'border-neutral-200 hover:border-neutral-300',
              )}
              onClick={() => onSelect(plan.unit)}
              onKeyDown={(e) => e.key === 'Enter' && onSelect(plan.unit)}
            >
              <div className={clsx(
                'w-5 h-5 mt-1 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors',
                isSelected
                  ? 'border-llama-purple-4 bg-llama-purple-4'
                  : 'border-neutral-300 bg-white',
              )}>
                {isSelected && <div className='w-2 h-2 rounded-full bg-white' />}
              </div>
              <div className='flex-1 min-w-0'>
                <p className='text-base font-bold text-llama-grey-7'>{plan.name}</p>
                <PriceDisplay plan={plan} selectedUnit={selectedUnit} estimate={estimate} />
              </div>
              {plan.current && (
                <span className='text-xs font-bold bg-neutral-200 text-llama-grey-7 px-2 py-0.5 rounded shrink-0'>
                  Current
                </span>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
